'use strict';

import { Entity } from '../Entity';
import { GlobSunfireOrg } from '../Glob/GlobSunfireOrg';
import { AgencyConnecture } from './AgencyConnecture';
import { AgencySetting } from './AgencySetting';
import { AgencyLogo } from './AgencyLogo';
import { AgencyLeadStatus } from './AgencyLeadStatus';
import { AgencyLeadStatusCollection } from '../../Collections/Agency/AgencyLeadStatusCollection';
import { GlobSunfireOrgCollection } from '../../Collections/Glob/GlobSunfireOrgCollection';

export class Agency extends Entity {
  protected agencyId;
  protected agencyName;
  protected agencyPhone;
  protected agencyEmail;
  protected agencyAddressStreet;
  protected agencyAddressUnit;
  protected agencyAddressCity;
  protected agencyAddressState;
  protected agencyAddressZip;
  protected agencyOrigin;
  protected autoCnxAccess;
  protected autoSunfireAccess;
  protected sunfireOrg;
  protected connecture;
  protected settings;
  protected agencyLeadStatus;
  protected agencyLogo;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.agencyId = data.agencyId;
    this.agencyName = data.agencyName;
    this.agencyPhone = data.agencyPhone;
    this.agencyEmail = data.agencyEmail;
    this.agencyAddressStreet = data.agencyAddressStreet;
    this.agencyAddressUnit = data.agencyAddressUnit;
    this.agencyAddressCity = data.agencyAddressCity;
    this.agencyAddressState = data.agencyAddressState;
    this.agencyAddressZip = data.agencyAddressZip;
    this.agencyOrigin = data.agencyOrigin;
    this.autoCnxAccess = data.autoCnxAccess;
    this.autoSunfireAccess = data.autoSunfireAccess;

    if (data.sunfireOrg) {
      const sunfire = new GlobSunfireOrg();

      sunfire.hydrate(data.sunfireOrg);

      this.sunfireOrg = sunfire;
    }

    if (data.connecture) {
      const con = new AgencyConnecture();

      con.hydrate(data.connecture);

      this.connecture = con;
    }

    if (data.settings) {
      const settings = new AgencySetting();

      settings.hydrate(data.settings);

      this.settings = settings;
    }

    if (data.logo) {
      const logo = new AgencyLogo();

      logo.hydrate(data.logo);

      this.agencyLogo = logo;
    }

    if (data.agencyLeadStatus) {
      const leadStatusOptions = new AgencyLeadStatusCollection();

      data.leadStatusOptions.forEach((singleLeadStatusOption) => {
        const leadStatusOption = new AgencyLeadStatus();
        leadStatusOption.hydrate(singleLeadStatusOption);

        leadStatusOptions.addItem(leadStatusOption);
      });

      this.agencyLeadStatus = leadStatusOptions;
    }
    /*
    if (data.sunfireOrg) {
      let sunfireOrgs = new GlobSunfireOrgCollection();

      data.sunfireOrg.forEach(singleSunfireOrgData => {
        let org = new GlobSunfireOrg();
        org.hydrate(singleSunfireOrgData);

        sunfireOrgs.addItem(org);
      });

      this.sunfireOrg = sunfireOrgs;
    }
    */
  }

  public getAgencyId() {
    return this.agencyId;
  }

  public getAgencyName() {
    return this.agencyName;
  }

  public getAutoCnxAccess() {
    return this.autoCnxAccess;
  }

  public getAutoSunfireAccess() {
    return this.autoSunfireAccess;
  }

  public getSunfireOrg() {
    return this.sunfireOrg;
  }

  public getConnecture() {
    return this.connecture;
  }

  public getAgencyLogo(): AgencyLogo {
    return this.agencyLogo;
  }
}
